import { Box, BoxProps } from '../Box';

export const ModalFooter = ({ css, ...rest }: BoxProps) => (
  <Box css={{ gridArea: 'footer', ...css }} {...rest} />
);
